import React from 'react';
import { Redirect } from 'react-router-dom';

import './Details.css';
import sample_pic from '../pexels-christina-morillo-1181605.jpg';

import {
  Grid,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Button,
  Typography,
  Divider,
  DialogTitle,
  Dialog,
} from '@material-ui/core';


class Details extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      dialogOpen: false,
      previewDialogOpen: false,
      edit: false,
    };
  }

  handleDialogToggle = (state = false) => {
    this.setState({dialogOpen: state});
  }

  handlePreviewDialogToggle = (state = false) => {
    if(this.props.data.previewUrl)
      this.setState({previewDialogOpen: state});
  }

  handleFileDelete = () => {
    this.props.onDelete(this.props.data.path);
  }

  handleEdit = () => {
    this.setState({ edit: true });
  }

  render() {
    return (
      <Card className="details">
        <CardContent className="m-3">
          <Grid container spacing={3}>
            <Typography className="w-100" align="center" variant="h5" component="h2">{this.props.data.title}</Typography>
            <Divider />
            <div className="w-100 mb-2 details-image"><img src={this.props.data.imageUrl} alt="file-preview" onClick={() => this.handlePreviewDialogToggle(true)}/></div>
            <Divider />
            <Typography className="w-100" component="p" display="block"><strong>File Name:</strong> {this.props.data.fileName}</Typography>
            <Typography className="w-100" component="p"><strong>Folder:</strong> {this.props.data.folder}</Typography>
            <Typography className="w-100" component="p"><strong>Date:</strong> {this.props.data.date}</Typography>
            <Typography className="w-100" component="p"><strong>People:</strong> {this.props.data.people}</Typography>
            <Typography className="w-100" component="p"><strong>Clinic Code:</strong> {this.props.data.clinicCode}</Typography>
            <Typography className="w-100" component="p"><strong>Category:</strong> {this.props.data.category}</Typography>
            <Typography className="w-100" component="p"><strong>File Type:</strong> {this.props.data.fileType}</Typography>
            <Typography className="w-100" component="p"><strong>Uploaded By:</strong> {this.props.data.uploadedBy}</Typography>
            <Typography className="w-100" component="p" gutterBottom><strong>Description:</strong> {this.props.data.description}</Typography>
          </Grid>
        </CardContent>
        <CardActions>
          <Button size="small" onClick={() => this.props.callback()}>Close</Button>
          <Button size="small" onClick={this.handleEdit}>Edit</Button>
          <Button size="small" onClick={() => this.handleDialogToggle(true)}>Delete</Button>
          <Button size="small" href={this.props.data.downloadUrl}>Download</Button>
        </CardActions>
        <Dialog onClose={() => this.handleDialogToggle()} aria-labelledby="file-delete-confirm" open={this.state.dialogOpen}>
          <DialogTitle id="file-delete-confirm">Confirm Delete?</DialogTitle>
          <Button onClick={this.handleFileDelete}>Delete</Button>
          <Button onClick={() => this.handleDialogToggle()}>Cancel</Button>
        </Dialog>
        <Dialog onClose={() => this.handlePreviewDialogToggle()} aria-labelledby="preview video" open={this.state.previewDialogOpen}>
          <Card>
            <CardMedia 
            component="video"
            controls
            allow="fullscreen"
            src={this.props.data.previewUrl}
            autoPlay />
          </Card>
        </Dialog>
        {this.state.edit ? <Redirect to={{ pathname: '/edit', state: { files: [this.props.data] } }} /> : null}
      </Card>
    )
  }
}

Details.defaultProps = {
  callback: () => {},
  data: {
    title: 'Marketing Fileshare File',
    imageUrl: sample_pic,
    fileName: 'interview.mp4',
    fileType: 'mp4',
    date: '01/01/1900',
    people: 'Bob Johnson',
    category: 'interview',
    clinicCode: 'UTHA',
    tags: [],
    description: 'A file that contains footage of an interview of Dr. Bob Johnson.',
    downloadUrl: null,
    previewUrl: null,
  },
  onDelete: () => {},
};

export default Details;